import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { UserUrls } from "../../UserManagement";
import UserParent from "../../UserManagement/UserNew/util/UserParent";
import UserTable from "../../../components/UserTable";
import { getCompanyId, getOrganisationType, getUserEmail } from "../../../Authentication/Auth";

const CompanyUsers = ({
  match: {
    params: { id },
  },
  location: { state },
}: RouteComponentProps<
  { readonly id: string },
  {},
  { readonly name: string }
>) => {
  const { name = "" } = state ?? {};
  localStorage.setItem("UserSearchPageNumber", "0");
  const organisationName = sessionStorage.getItem("OrganisationName");
  return (
    <UserTable
      subtitle={name}
      queryParams={{
        organisationName: name,
        userId: getUserEmail(),
        UserOrganisationType: getOrganisationType(),
        UserOrganisationId: Number(getCompanyId()),
        UserOrganisationName: organisationName,
      }}
      createUrl={UserUrls.create({ [UserParent.COMPANY]: id })}
      pagination="prevNext"
      cacheMechanism={true}
    />
  );
};

export default CompanyUsers;
